import React from 'react';
import { PhoneIcon, MessageSquareIcon } from 'lucide-react';
const TopBar = () => {
  return <div className="bg-gray-800 text-white py-2 px-4" data-id="element-359" data-mp="232domw3nlgs8">
      <div className="container mx-auto flex justify-end items-center gap-3" data-id="element-360" data-mp="234zxcz2a62c1">
        <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-amber-500 hover:bg-amber-600 px-3 py-1 rounded transition-colors" data-id="element-361" data-mp="1y4c7igpsfrje">
          <span className="font-medium" data-id="element-362" data-mp="2lt4ydyrjz975">Book Now</span>
        </a>
        <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-burgundy-600 hover:bg-burgundy-700 px-3 py-1 rounded transition-colors" data-id="element-363" data-mp="2h2oga1csezeg">
          <MessageSquareIcon size={16} data-id="element-364" data-mp="39l23z84et4zt" />
          <span className="font-medium" data-id="element-365" data-mp="34rzat13jnxk5">Enquire Now</span>
        </a>
        <a href="tel:07481300600" className="flex items-center gap-2 bg-burgundy-600 hover:bg-burgundy-700 px-3 py-1 rounded transition-colors" data-id="element-366" data-mp="257ts1m62zea">
          <PhoneIcon size={16} data-id="element-367" data-mp="661fcoc50240" />
          <span className="font-medium" data-id="element-368" data-mp="3ol2b5vwrjiat">Call Now: 07481 300 600</span>
        </a>
      </div>
    </div>;
};
export default TopBar;